/**
 * Fallback UI locale for Pet Taxi / Booking when a country has no dedicated copy.
 * Currency always comes from stripeCurrency.getPrimaryCurrency(countryCode).
 */

export const MARKET_LOCALE_FALLBACK = {
  AT: 'AT',
  BA: 'DE',
  BE: 'FR',
  BG: 'DE',
  CH: 'DE',
  CZ: 'DE',
  DK: 'DK',
  EE: 'DE',
  ES: 'PT',
  FI: 'FI',
  FR: 'FR',
  GB: 'GB',
  HR: 'DE',
  HU: 'HU',
  IE: 'GB',
  IS: 'GB',
  IT: 'IT',
  LT: 'DE',
  LV: 'DE',
  MD: 'RO',
  MY: 'GB',
  NL: 'DE',
  NO: 'NO',
  PL: 'PL',
  PT: 'PT',
  RO: 'RO',
  SE: 'SE',
  SK: 'DE',
};

/** Stripe/Vinted checkout dictionary key per country */
export const MARKET_STRIPE_LOCALE = {
  AT: 'DE',
  BA: 'DE',
  BE: 'NL',
  BG: 'DE',
  CH: 'DE',
  CZ: 'CZ',
  DK: 'DK',
  EE: 'EE',
  ES: 'ES',
  FI: 'FI',
  FR: 'FR',
  GB: 'IE',
  HR: 'HR',
  HU: 'HU',
  IE: 'IE',
  IS: 'IS',
  IT: 'IT',
  LT: 'LT',
  LV: 'LV',
  MD: 'RO',
  MY: 'IE',
  NL: 'NL',
  NO: 'NO',
  PL: 'PL',
  PT: 'PT',
  RO: 'RO',
  SE: 'SE',
  SK: 'SK',
};

export function normalizeMarketCountryCode(countryCode) {
  const cc = (countryCode || '').trim().toUpperCase();
  if (!cc) return 'GB';
  return cc === 'UK' ? 'GB' : cc;
}

export function resolveMarketLocaleCountry(countryCode) {
  const cc = normalizeMarketCountryCode(countryCode);
  return MARKET_LOCALE_FALLBACK[cc] || cc;
}

export function resolveMarketStripeLocale(countryCode) {
  const cc = normalizeMarketCountryCode(countryCode);
  return MARKET_STRIPE_LOCALE[cc] || MARKET_LOCALE_FALLBACK[cc] || 'IE';
}
